import _ from 'lodash';
import LogRocket from 'logrocket';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { AuthService } from '@services/auth.service';
import { Router } from '@angular/router';
import { MessageService } from '@services/message.service';
import { Title } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { SocialAuthService, GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.scss']
})
export default class LoginComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private messageS: MessageService,
    private route: ActivatedRoute,
    private titleService: Title,
    private formBuilder: UntypedFormBuilder,
    private socialAuthService: SocialAuthService
  ) {


    this.socialAuthService.signOut(true).then(res => {
    })
      .catch(err => {
      });
    localStorage.clear();
  }

  loginForm = this.formBuilder.group({
    username: ['', Validators.required],
    password: ['', Validators.required]
  });

  url_return;
  user_info;
  stateChange$: Subscription;


  ngOnInit() {
    this.titleService.setTitle(`Sports Informations ${environment.version}`);

    this.route.queryParams
      .subscribe(params => {
        this.url_return = params.return;
      });

    this.stateChange$ = this.socialAuthService.authState.subscribe((res) => {
      if (res) {
        this.user_info = res;
        this.login({ id: res.id, platform: res.provider })
      }
    });
  }

  login(params) {
    this.authService.login(params)
      .subscribe({
        next: this.loginHandler.bind(this),
        error: this.loginErrorHandler.bind(this),
      });
  }

  googleLogin() {
    this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID).then(res => {
    })
      .catch(err => {
        this.messageS.updateEnvelop({ type: 'error', message: 'Login Unsuccessfully 登录失败' })
      })
  }

  facebookLogin() {
    this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID).then(res => {
    })
      .catch(err => {
        this.messageS.updateEnvelop({ type: 'error', message: 'Login Unsuccessfully 登录失败' })
      })
  }


  loginHandler(response) {
    if (!response.data) {
      const password = window.prompt('Please enter Invitation PIN \n请输入邀请码');
      if (password) {

        console.log('this.user_info', this.user_info);

        this.authService.register({ password, id: this.user_info.id, name: this.user_info.name, platform: this.user_info.provider })
          .subscribe({
            next: this.handleLoginPinSuccess.bind(this),
            error: this.handleLoginPinError.bind(this)
          })
      }
      return;
    }

    const user = response.data;
    const queryParamsValues = {};
    localStorage.setItem('name', response.data.name);
    localStorage.setItem('language', 'en');
    let url_landing = user.url_landing;
    if (this.url_return) {
      url_landing = this.url_return;
      const querySplitters = url_landing.split('?');
      if (querySplitters.length > 1) {
        // means have query params, leave out original url from query string
        url_landing = querySplitters[0];

        for (let i = 1; i < querySplitters.length; i++) {
          const query = querySplitters[i].split('=');
          queryParamsValues[query[0]] = query[1];
        }
      }
    }

    this.stateChange$?.unsubscribe()
    this.router.navigate([url_landing], { queryParams: queryParamsValues });

    this.messageS.updateEnvelop({ type: 'success', message: `Login Successfully 登录成功`, });
    setTimeout(() => {
      this.messageS.restart();
    }, 2000);
  }

  loginErrorHandler(response) {
    return this.messageS.updateEnvelop({
      type: 'error',
      message: `Invalid Invitation PIN 邀请码错误`,
    });
  }


  handleLoginPinSuccess(response) {
    this.login({ id: this.user_info.id, platform: this.user_info.provider })
    this.messageS.updateEnvelop({
      type: 'success',
      message: `Login Successfully 登录成功`,
    });
  }

  handleLoginPinError(error) {
    switch (error.status) {
      case 400: return this.messageS.updateEnvelop({ type: 'error', message: `Invalid Invitation PIN 邀请码错误`, });
      case 422: return this.messageS.updateEnvelop({ type: 'error', message: `Invalid Invitation PIN 邀请码错误`, });
    }
  }

}

export { LoginComponent };
